import { shuffle } from 'shuffle-seed';

export interface GetDefaultContentArgs<T> {
  items: T[];
  numItemsToReturn: number;
  seed: string;
}

/**
 * Takes an array of items and returns a random subset in a deterministic fashion
 *
 * @param items - collection of items to randomize, bisect, and return
 * @param numItemsToReturn - number of items to return
 * @param seed - used to guarantee a deterministic result
 **/
export function getDefaultContent<T>({
  items,
  numItemsToReturn,
  seed,
}: GetDefaultContentArgs<T>): T[] {
  if (numItemsToReturn <= 0) {
    return [];
  }

  const sortedItems = shuffle(items, seed);

  return sortedItems.slice(0, numItemsToReturn);
}
